import styled from "styled-components";
import { colors } from "styles/colors";
export { FormRow, Button, Loading } from "styles/styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  max-width: 680px;
  max-height: 90vh;
  flex-direction: column;
  background-color: ${colors.white};
  border-radius: 4px;
  padding: 40px;
  margin: 32px 0;

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: ${colors.line};
    border-radius: 3px;
  }
`;

export const Header = styled.div`
  display: flex;
  width: 100%;
  padding-bottom: 24px;
  margin-bottom: 24px;
  border-bottom: 1px ${colors.line} solid;
`;

export const Title = styled.h1`
  display: flex;
  align-items: center;
  font-size: 20px;
  color: ${colors.black};
`;

export const Text = styled.p`
  display: flex;
  align-items: center;
  margin-bottom: 30px;
`;

export const ButtonsWrapper = styled.div`
  border-top: 1px ${colors.line} solid;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  border-left: none;
  border-right: none;
  padding-top: 15px;

  button:first-child {
    margin-right: 16px;
  }
`;
